iScreenWizard.factory('Gebruikersbericht', function ($q, Ajax) {

    var data = {};

    data.countUnread = function() {
        params = {
            countonly: 1,
            gelezen_door_gebruiker: 0
        };
        return $q(function (resolve, reject) {
            Ajax.get('gebruikersbericht', params).then(function (response) {
                var count = response.data.count;
                resolve(count);
            }, reject);
        });
    };

    data.all = function(pageSize, page) {
        params = {
            orderby: 'datum',
            orderdesc: 1
        };
        if (!isNaN(pageSize)) {
            params.pagesize = pageSize;
            params.page = 1;
            if (!isNaN(page)) {
                params.page = page;
            }
        }
        return $q(function (resolve, reject) {
            Ajax.get('gebruikersbericht', params).then(function (response) {
                var gebruikersberichten = response.data;
                resolve(gebruikersberichten);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('gebruikersbericht/'+id).then(function (response) {
                var gebruikersbericht = response.data;
                resolve(gebruikersbericht);
            }, reject);
        });
    };

    data.markAsRead = function(gebruikersbericht) {
        params = {
            _method: 'gelezen',
            id: gebruikersbericht.id
        };
        return $q(function (resolve, reject) {
            Ajax.get('gebruikersbericht', params).then(function (response) {
                resolve();
            }, reject);
        });
    };

    return data;
});